var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubirFormatoAltaBajaEmpleado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c7e3f9;}.cls-2{fill:#9a725f;}.cls-3{fill:#f3d585;}.cls-4{fill:#ce732f;}.cls-5{fill:#f4e0b6;}.cls-6{fill:#c3a998;}.cls-7{fill:#333;}.cls-8{fill:#7ac943;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subir_formato_alta_baja_empleado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114,76.56H85.69L81.22,87H60.37L55.9,76.56H27.6L41,24.42h59.59L114,76.56v34.26H27.6V76.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.43,30.38H90.16V46.16H51.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.2,37.83H57.39a1.49,1.49,0,0,1,0-3H84.2a1.49,1.49,0,0,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,43.78H94.63v15H47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.67,51.23H52.92a1.49,1.49,0,0,1,0-3H88.67a1.49,1.49,0,0,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.49,57.19H99.1v47.67H42.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114,110.82H27.6V76.56H55.9L60.37,87H81.22l4.47-10.42H114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.37,92.94H81.22a3,3,0,0,1,3,3v6a3,3,0,0,1-3,3H60.37a3,3,0,0,1-3-3v-6A3,3,0,0,1,60.37,92.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.41,64.64H49.94a1.49,1.49,0,1,1,0-3h4.47a1.49,1.49,0,1,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.77,70.6H49.94a1.49,1.49,0,1,1,0-3H73.77a1.49,1.49,0,1,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.65,70.6H79.73a1.49,1.49,0,0,1,0-3H91.65a1.49,1.49,0,1,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.55,98.9a1.49,1.49,0,0,1-1.49-1.49V82.51a1.49,1.49,0,0,1,3,0v14.9A1.49,1.49,0,0,1,33.55,98.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.55,106.35a1.49,1.49,0,0,1-1.49-1.49v-1.49a1.49,1.49,0,1,1,3,0v1.49A1.49,1.49,0,0,1,33.55,106.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "115.88 90.51 96.32 71.28 77.09 90.83 90.9 90.72 90.9 120.58 102.07 120.58 102.07 90.62 115.88 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "117.4 88.27 97.85 69.04 78.62 88.59 92.43 88.48 92.43 118.34 103.6 118.34 103.6 88.38 117.4 88.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirFormatoAltaBajaEmpleado);
export default __webpack_public_path__ + "static/media/subir_formato_alta_baja_empleado.237ca9eb3402fd5d78bd1d1ff7521906.svg";
export { ForwardRef as ReactComponent };